import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { api } from '../lib/api';
import toast from 'react-hot-toast';

export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [totpKoda, setTotpKoda] = useState(''); // [PATCH 2fa v1]
  const [zahteva2fa, setZahteva2fa] = useState(false);
  const [napacnoGeslo, setNapacnoGeslo] = useState(false); // [PATCH pozabljeno-geslo-fe v1]
  const { setAuth, theme, toggleTheme } = useAuthStore();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login', { email, password, totp_code: totpKoda || undefined }); // [PATCH 2fa v1]
      setAuth(data.access_token, data.user_id, data.tenant_id, data.role);
      navigate('/');
    } catch (err: any) {
      const d = err.response?.data?.detail; // [PATCH 2fa v1]
      if (d === '2FA_KODA') { setZahteva2fa(true); toast('Vpišite 6-mestno kodo iz aplikacije.'); }
      else { toast.error(typeof d === 'string' ? d : 'Napaka pri prijavi'); if (d === 'Napačen email ali geslo') setNapacnoGeslo(true); } // [PATCH pozabljeno-geslo-fe v1]
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-gray-50 dark:bg-gray-950">
      {/* Left - branding */}
      <div className="hidden lg:flex lg:w-1/2 bg-blue-600 items-center justify-center p-12">{/* [PATCH login-samo-logo v1] samo logo */}
        <div className="flex items-center gap-4">
          <svg viewBox="-2 14 86 82" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="h-16 w-auto">
            <polygon points="46.5,20.7 40.5,19 35.3,21.8 3.5,72.8 15.7,72.5 23.2,61.2 37.2,60.7 42.3,52.3 29.2,52.3 29,51.3 41.2,32 52.3,47.7 58.7,39.3" fill="#FFFFFF" />
            <polygon points="39.8,72.5 49.3,72.8 59.3,58 60.3,57.7 70.5,72.8 80.2,72.8 61.8,44.7 59.8,44.7" fill="#BFDBFE" />
          </svg>
          <span className="text-white text-5xl font-extrabold tracking-tight">Alfa<span className="text-blue-200">Berg</span></span>
        </div>
      </div>

      {/* Right - form */}
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <div className="flex justify-between items-center mb-8">
            <div>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Dobrodošli</h2>
              <p className="text-gray-500 dark:text-gray-400 mt-1">Prijavite se v AlfaBerg</p>
            </div>
            <button onClick={toggleTheme}
              className="p-2 rounded-lg bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300">
              {theme === 'dark' ? '☀️' : '🌙'}
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Email
              </label>
              <input
                type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 rounded-xl border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition"
                placeholder="vas@email.si" required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Geslo
              </label>
              <input
                type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 rounded-xl border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition"
                placeholder="••••••••" required
              />
            </div>
            {zahteva2fa && ( /* [PATCH 2fa v1] */
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  2FA koda
                </label>
                <input
                  value={totpKoda} onChange={(e) => setTotpKoda(e.target.value)}
                  inputMode="numeric" maxLength={6} autoFocus
                  className="w-full px-4 py-3 rounded-xl border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition"
                  placeholder="6-mestna koda iz aplikacije" required
                />
              </div>
            )}
            <button type="submit" disabled={loading}
              className="w-full py-3 px-4 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white font-semibold rounded-xl transition">
              {loading ? 'Prijavljam...' : 'Prijava'}
            </button>
          </form>

          {/* [PATCH pozabljeno-geslo-fe v1] povezava vedno; ob napačnem geslu poudarjena */}
          {napacnoGeslo ? (
            <div className="mt-4 p-3 rounded-xl bg-blue-50 dark:bg-blue-900/30 border border-blue-200 dark:border-blue-800 text-sm text-gray-700 dark:text-gray-200 text-center">
              Ste pozabili geslo?{' '}
              <Link to={'/pozabljeno-geslo' + (email ? '?email=' + encodeURIComponent(email) : '')}
                className="text-blue-600 dark:text-blue-400 font-semibold hover:underline">
                Pošljite si povezavo za novo geslo
              </Link>
            </div>
          ) : (
            <p className="mt-4 text-center text-sm">
              <Link to="/pozabljeno-geslo" className="text-blue-600 hover:underline">Pozabljeno geslo?</Link>
            </p>
          )}

          {/* [PATCH login-brez-registracije v1] povezava na /registracija odstranjena - javna registracija je zaprta */}
        </div>
      </div>
    </div>
  );
}
